import Loading from "../Elements/Loading/Loading.tsx";
import ApiErrorMessage from "../Message/ApiErrorMessage.tsx";

const LoadingOrError = ({ state }: LoadingOrErrorType) => {
  if (Array.isArray(state)) {
    if (state.find(({ isLoading }) => isLoading)) {
      return <Loading />;
    } else if (state.find(({ isRejected }) => isRejected)) {
      return <ApiErrorMessage error={state.map(({ error }) => error)} />;
    } else {
      return null;
    }
  } else {
    if (state.isLoading) {
      return <Loading />;
    } else if (state.isRejected) {
      return <ApiErrorMessage error={state.error} />;
    } else {
      return null;
    }
  }
};

type LoadingOrErrorType = {
  state: {
    error: Response;
    isLoading: boolean;
    isRejected: boolean;
  };
};

export default LoadingOrError;
